import { useTranslations } from '@vocab/react';
import {
  Box,
  ContentBlock,
  Heading,
  Stack,
  Text,
  TextLink,
} from 'braid-design-system';
import type { FC } from 'react';
import { SearchErrorIcon } from 'src/shared/icons/SearchErrorIcon';
import translations from './.vocab';
import { useAppConfig } from 'src/constants/AppConfig/AppConfigProvider';
import { isANZSite } from 'src/utils/site';
import {
  getAnzCsPhoneNumberFromSite,
  getHelpCentreUrlFromSite,
} from '../../../utils/getCsContactMethodMessageFromSite.ts';

export const MainContentError: FC = () => {
  const { t } = useTranslations(translations);
  const { site, language } = useAppConfig();

  const isSiteAnz = isANZSite(site);

  const anzCsPhoneNumber = getAnzCsPhoneNumberFromSite(site);

  return (
    <ContentBlock width="large">
      <Box
        background="surface"
        paddingY={['xxlarge', 'xlarge']}
        paddingX="gutter"
      >
        <Stack space="xlarge" align="center">
          <SearchErrorIcon />
          <Stack space="gutter">
            <Heading level="3" align="center">
              {t('Can we try that again?')}
            </Heading>
            <Text align="center">
              {t(
                "Bear with us, we're having technical issues. Try refreshing the page.",
              )}
            </Text>
            {isSiteAnz ? (
              <Text align="center">
                {t(
                  "If it still doesn't work, reach out to our Customer Service team on <Link>csPhoneNumber</Link>.",
                  {
                    csPhoneNumber: anzCsPhoneNumber,
                    Link: (csPhoneNumber) => (
                      <TextLink href={`tel:${csPhoneNumber}`}>
                        {csPhoneNumber}
                      </TextLink>
                    ),
                  },
                )}
              </Text>
            ) : (
              <Text align="center">
                {t(
                  "If it still doesn't work, reach out to our <Link>Customer Service team</Link>.",
                  {
                    Link: (children) => (
                      <TextLink href={getHelpCentreUrlFromSite(site, language)}>
                        {children}
                      </TextLink>
                    ),
                  },
                )}
              </Text>
            )}
          </Stack>
        </Stack>
      </Box>
    </ContentBlock>
  );
};
